import { orange } from '@ant-design/colors';
import { rgba } from 'polished';
import { createGlobalStyle, css } from 'styled-components';

const SUPPORT_PICKER_COLOR = orange[5];

// Shared popup styling for the wide range pickers: centered input and 600px panels.
const basePickerStyles = css`
  .ant-picker {
    .ant-picker-input > input {
      text-align: center;
    }
  }

  .ant-picker-panels {
    width: 600px;
  }
`;

export const PickerPopupStyles = createGlobalStyle`
  ${basePickerStyles}
`;

// Staff-only variant: the shared popup styling plus an orange accent on the control.
export const SupportPickerStyles = createGlobalStyle`
  ${basePickerStyles}

  .ant-picker {
    border-color: ${SUPPORT_PICKER_COLOR};

    &:hover {
      border-color: ${SUPPORT_PICKER_COLOR};
      box-shadow: 0 0 0 2px ${rgba(SUPPORT_PICKER_COLOR, 0.2)};
    }
  }

  .ant-picker-focused {
    border-color: ${SUPPORT_PICKER_COLOR};
    box-shadow: 0 0 0 2px ${rgba(SUPPORT_PICKER_COLOR, 0.2)};
  }

  .ant-picker-range .ant-picker-active-bar {
    background: ${SUPPORT_PICKER_COLOR};
  }
`;
